import React from "react";
import { Formik } from "formik";
import { Form, Col, Row } from "react-bootstrap";

export function SubjectOutcomeEditForm({ 
  subjectOutcome,
  btnRef,
  saveSubjectOutcome
}) {
  return (
    <Formik 
      enableReinitialize={true}
      initialValues={subjectOutcome}
      onSubmit={(values) => saveSubjectOutcome(values)}
    >
      {({ handleSubmit, handleChange, values }) => (
        <Form onSubmit={(e) => {
          e.preventDefault();
          handleSubmit();
        }}>
          <Form.Group as={Row} controlId="outcome">
            <Form.Label column sm={2}>
              Kazanım<span> *</span>
            </Form.Label>
            <Col sm={10}>
              <Form.Control type="text" value={values.outcome} placeholder="Kazanım" onChange={handleChange} />
            </Col>
          </Form.Group>
          
          <Form.Group as={Row} controlId="explanation">
            <Form.Label column sm={2}>
              Açıklaması
            </Form.Label>
            <Col sm={10}>
              <Form.Control type="text" value={values.explanation} placeholder="Açıklaması" onChange={handleChange} />
            </Col>
          </Form.Group>

          <button
            type="submit"
            style={{ display: "none" }}
            ref={btnRef}
          ></button>
        </Form>
      )}      
    </Formik>
  );
}